<div class="gap-sm flex w-full items-center">
  <app-chip
    [variant]="etape().estOuverte ? 'positive' : 'negative'"
    [label]="etape().estOuverte ? 'Ouverte' : 'Fermée'"
  />
  <div class="flex flex-1 flex-col">
    <span class="component-medium-semibold">{{ etape().nom }}</span>
    <span class="component-small-medium text-components-content-neutral-secondary">{{ etape().codeEtape }}</span>
  </div>
  <div>
    <hlm-radio-indicator indicator />
  </div>
</div>
<div class="gap-xs text-components-content-neutral-tertiary flex items-center">
  <ng-icon name="lucideClock" hlm size="sm" />
  <span class="text-components-content-neutral-primary">{{ etape().duree | i18nPlural: anMapping }}</span>
  <span class="text-components-content-neutral-primary">&middot;</span>
  <ng-icon name="lucideBadgeCheck" hlm size="sm" />
  <span class="text-components-content-neutral-primary">{{ certification() }}</span>
</div>
